import apiCall from '@/store/apiCall';
import URLS from '@/store/urls';
import notificationWithIcon from '@/utils/notification';
import types from './types';

export default {
  async getApiKeys({ commit }) {
    try {
      commit(types.GET_API_KEYS_START);
      const { data: { data } } = await apiCall({
        type: 'GET',
        url: URLS.analyticsApiKeys,
        isToken: true,
      });
      commit(types.GET_API_KEYS_SUCCESS, data);
    } catch (e) {
      const message = e.response?.data?.message || e.message;
      notificationWithIcon('error', message);
      commit(types.GET_API_KEYS_FAILURE, message);
    }
  },

  async createApiKey({ commit, dispatch }, payload) {
    try {
      commit(types.CREATE_API_KEY_START);
      const { data: { data } } = await apiCall({
        type: 'POST',
        url: URLS.analyticsApiKeys,
        body: payload,
        isToken: true,
      });
      commit(types.CREATE_API_KEY_SUCCESS, data);
      notificationWithIcon('success', 'API key generated successfully');
      dispatch('getApiKeys');
      return data;
    } catch (e) {
      const message = e.response?.data?.message || e.message;
      notificationWithIcon('error', message);
      commit(types.CREATE_API_KEY_FAILURE, message);
      throw e;
    }
  },

  async extendApiKey({ commit, dispatch }, { id, expiresInDays }) {
    try {
      commit(types.EXTEND_API_KEY_START);
      await apiCall({
        type: 'PUT',
        url: `${URLS.analyticsApiKeys}/${id}/extend`,
        body: { expiresInDays },
        isToken: true,
      });
      commit(types.EXTEND_API_KEY_SUCCESS);
      notificationWithIcon('success', 'API key extended successfully');
      dispatch('getApiKeys');
    } catch (e) {
      const message = e.response?.data?.message || e.message;
      notificationWithIcon('error', message);
      commit(types.EXTEND_API_KEY_FAILURE, message);
      throw e;
    }
  },

  async revokeApiKey({ commit, dispatch }, id) {
    try {
      commit(types.REVOKE_API_KEY_START);
      await apiCall({
        type: 'DELETE',
        url: `${URLS.analyticsApiKeys}/${id}`,
        isToken: true,
      });
      commit(types.REVOKE_API_KEY_SUCCESS);
      notificationWithIcon('success', 'API key revoked successfully');
      dispatch('getApiKeys');
    } catch (e) {
      const message = e.response?.data?.message || e.message;
      notificationWithIcon('error', message);
      commit(types.REVOKE_API_KEY_FAILURE, message);
      throw e;
    }
  },
};
